import { Component, input, output, model } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'ui-search-input',
  standalone: true,
  imports: [IconFieldModule, InputIconModule, InputTextModule, CommonModule, FormsModule, TranslatePipe],
  template: `
    <p-iconfield>
      <p-inputicon styleClass="pi pi-search" />
      <input 
        pInputText 
        [placeholder]="placeholder() | translate" 
        [ngModel]="value()" 
        (ngModelChange)="onModelChange($event)" 
        class="search-input" 
      />
    </p-iconfield>
  `,
  styles: [`
    .search-input { min-width: 280px; width: 100%; max-width: 100%; }
  `]
})
export class SearchInputComponent {
  /** The translation key or text for the placeholder */
  placeholder = input('COMMON.SEARCH');
  
  /** Two-way bindable search value */
  value = model<string>('');
  
  /** Emits when the user types, debounced by 300ms. Perfect for triggering table resets. */
  searchChange = output<string>();

  private timeoutId: any;

  onModelChange(val: string) {
    this.value.set(val);
    
    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.searchChange.emit(val);
    }, 300);
  }
}
